import PageContent from '../components/PageContent';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';

function Audio() {
  return (
    <PageLayout>
      <PageTitle>
        Audio
      </PageTitle>
      <PageContent>
        Stuff about sound. Stuff about ableton, stuff about plugins.
      </PageContent>
    </PageLayout>
  );
}

export default Audio;
